import React from "react";
import Shadow from "../Shadow";
import RadioBox from "../forms/RadioBox";
import GlassDepth from "./GlassDepth";
import { IDepth, IPrice } from "../../../types";

const Depth = ({ hasMaterial, shadowFalse, resetForm, shadow, data }) => {
  const depths: IPrice[] = data?.filter?.((el) => el?.depth?.millimetre);
  const reload = () => {
    shadowFalse(3);
    resetForm([
      "format",
      "formatMM1",
      "formatMM2",
      "processing",
      "processingValue",
    ]);
  };
  const depth = (v: IPrice): IDepth => v.depth;
  const mm = (v: IPrice) => depth(v).millimetre;
  return !!hasMaterial && !!data?.length ? (
    <div className={"bl_4_grid_item"}>
      {shadow && <Shadow />}
      <div className="calc_title_box">
        <div className="calc_title">Толщина</div>
        {depths.map((v) => (
          <RadioBox
            info={{ text: depth(v).description }}
            key={mm(v)}
            name={"depth"}
            value={mm(v)?.toString?.()}
            func={reload}
            txt={`${mm(v)}мм`}
          />
        ))}
      </div>
    </div>
  ) : (
    <GlassDepth shadow={shadow} />
  );
};

export default Depth;
